import React, { useMemo } from 'react';
import { PieChartOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import { InfoPopover } from '@bettercomp/ui-components';

import { formatMoney } from 'utils/finance';

import { Widget } from 'components/Statistic/Widget';
import { Label } from 'components/Statistic/Label';
import { Plan } from 'types';

import cn from './styles.module.scss';

type MetricsWidgetProps = {
  plan?: Plan,
  loading: boolean,
};

export function MetricsWidget({ plan, loading }: MetricsWidgetProps) {

  const metricsItems = useMemo(() => {
    if (plan) {
      const planStats = plan?.PlanStat?.stats;
      const currency = plan.currencyPlans?.find(({ id }) => id === planStats?.currencyId)?.currency?.code;
      const rate = 1;

      const payEquity = Math.round(planStats?.payEquity * 100);
      const avgMarket = Math.round(planStats?.avgMarket * 100);

      return [
        {
          value: !isNaN(avgMarket) ? `${avgMarket}%` : '-',
          title: 'Average Position to Market',
          description: 'Average % of market using base salary to base Market Reference Point',
        },
        {
          value: formatMoney({ num: planStats?.gapToMarket / rate, currency }),
          title: 'Average Gap to Market',
          description: 'Average $ gap to market, using base salary to base Market Reference Point',
        },
        {
          value: !isNaN(payEquity) ? `${payEquity}%` : '-',
          title: 'Gender Pay Gap',
          description: 'Average Female Salary vs. Average Male Salary',
        },
      ];
    }
    return [];
  }, [plan]);

  return (
    <Widget>
      <Label>
        <PieChartOutlined/> Market Metrics
      </Label>
      <Skeleton loading={loading} paragraph={{ rows: 3, width: '100%' }} active/>
      {metricsItems.map((item, index) => (
        <div key={index}>
          <div className={cn.metric}>{item.value}</div>
          <div>
            <span className={cn.title}>{item.title}</span>
            <InfoPopover
              title={item.title}
              content={item.description}
              overlayClassName={cn.infoPopover}
            />
          </div>
        </div>
      ))}
    </Widget>
  );
}
